export default __webpack_public_path__ + "static/media/immunitybooster.6423f6ce.jpg";